<template>
  <section class="travel-quote-info">
    <div class="box">
      <div class="table mg-b-10">
        <div class="tr">
          <span>Insured Period</span>
          <span
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('full_name')}">{{ formData.insurance_period}}</span>
        </div>
        <div class="tr">
          <span>Expected Insured Period</span>
          <span
            v-copy="formData.period_date "
            :class="{'green-tip':handleCompare('period_date')}">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </span>
        </div>
        <div class="tr">
          <span>Total Payable</span>
          <span
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ showAmount | formatMoney(2, true) }}</span>
        </div>
        <div class="tr">
          <span>Referrer</span>
          <span
            v-if="referrer"
            class="flex-column">
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:referrer.id}}"
              class="flex flex-wrap text-decoration-none">
              <span
                class="referrer"
                @click="handlerUser(referrer.id)">
                {{referrer.identity==2?referrer.isrd_com_nm:`${referrer.isrd_lst_nm||''} ${referrer.isrd_fst_nm||''}`}}
              </span>
            </router-link>
            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="referrer.verify_language"
                class="span-status"
                :class="{
                  'verified': referrer.verified == 20,
                  'pending_verify ': referrer.verified == -1,
                  'not_verify': referrer.verified == -2
                }">
                {{ referrer.verify_language }}
              </span>
              <span
                v-if="referrer.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </span>
        </div>
        <!--        <div-->
        <!--          v-if="formData.discount_str"-->
        <!--          class="tr">-->
        <!--          <span>Referrer Discount</span>-->
        <!--          <span>{{formData.discount_str}}</span>-->
        <!--        </div>-->
        <div
          v-if="!isEndorse"
          class="tr">
          <span>Policy Number </span>
          <span
            v-copy="formData.pcy_no "
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</span>
        </div>
        <div
          v-else
          class="tr">
          <span>Endorsement Number </span>
          <span
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</span>
        </div>
        <div class="tr">
          <span>Policy Reference Code </span>
          <span
            v-copy=" formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="excessList.length"
      class="box">
      <h3>Excess</h3>
      <div class="table">
        <div class="tr th">
          <span>Item</span>
          <span>Amount</span>
        </div>
        <div
          v-for="(inItem, index) in excessList"
          :key="index + inItem.premium"
          class="tr">
          <span>{{ inItem.item }}</span>
          <span
            v-copy="inItem.premium"
          >{{ inItem.premium }}</span>
        </div>
        <div class="tr">
          <span>Excess Remark</span>
          <span
            v-copy="changeLineData(formData.quote_remark)"
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></span>
        </div>
      </div>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <div
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <div
            v-if="excessIndex==0"
            class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span
              v-copy="subItem.premium"
            >{{ subItem.premium }}</span>
          </div>
          <div class="tr">
            <span>Coverage Remark</span>
            <span
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></span>
          </div>
        </div>
      </div>
    </div>
    <h3>Policy Details</h3>
    <travel-quote-info
      :formData="formData"
      :preFormData="preFormData"
      :compareList="compareList"></travel-quote-info>
    <div class="box">
      <h3>Remark(s)</h3>
      <div class="table">
        <div class="tr">
          <span>Remark</span>
          <span
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import TravelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import OMath from '@/utils/math'

export default {
  name: 'HousemaidPolicyInfo',

  components: {TravelQuoteInfo},
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions21
    },
    isDoula() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
    isDriver() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { is_driver } = data || {}
      return !!is_driver
    },
    coverageOptions() {
      const { coverage = [] } = this.localAllOptions
      if(this.isPartTime) {
        return coverage.filter(item => item.part_time === 1)
      }
      if(this.isDriver) {
        return coverage.filter(item => item.id === 2)
      }
      return coverage
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage} = quote_coverage_list||{}
      return  coverage
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  watch: {
    'formData.nationality_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.updateNationalityOptions(val)
        }
      }
    }
  },
  methods: {
    ...mapActions('common', ['updateNationalityOptions']),
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    getName(id){
      let data = this.coverageOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    }
  }
}
</script>
<style lang="scss" scoped>
.travel-quote-info{
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
